export const WOUND_LISTING_COLOUMS = [
    'Client Name',
    'Assessment Date',
    'Created At'
]
export const WOUND_SORTING_DATA = {
    'Client Name': 'clientName',
    'Assessment Date': 'date',
    'Created At': 'createdAt'
}
export const WOUND_DATA_MAPPING = {
    'Client Name': 'clientName',
    'Assessment Date': 'date',
    'Created At': 'createdAt'
}


export const WOUND_ENTRIES_LISTING_COLOUMS = [
    "Client Name",
    'Assessment Date',
    'Start Time',
    'End Time',
    'Created At'
]
export const WOUND_ENTRIES_SORTING_DATA = {
    'Client Name': 'clientName',
    'Assessment Date': 'date',
    'Start Time': 'startTime',
    'End Time': 'endTime',
    'Created At': 'createdAt'
}
export const WOUND_ENTRIES_DATA_MAPPING = {
    'Client Name': 'clientName',
    'Assessment Date': 'date',
    'Start Time': 'startTime',
    'End Time': 'endTime',
    'Created At': 'createdAt'
}

